module.exports = __webpack_public_path__ + "static/media/contractor.30a908ef.jpg";